import _ from 'lodash';

import {AsyncStatusesEnum} from '../../../../libs/shared/core/src/helpers/types/asyncStatuses';
import {AppParametricSelector, createSelector} from '../../../../srcCommon/helpers/reselectHelpers';
import {ActivityVisualTypesEnum} from '../../../models/api/activityModel';
import {getActivities, getMessages} from '../../../store/data/dataSelectors';
import {ViewerPanelPageState, ViewerPanelPageTypesEnum} from '../../../store/panels/viewer/viewerPanelState';

export type OptionalViewerPanelPageSelector<P> = AppParametricSelector<P, ViewerPanelPageState | undefined>;

/** Get the activities for the currently selected conversation. */
function makeGetViewerActivities<P>(getViewerPage: OptionalViewerPanelPageSelector<P>) {
  return createSelector([getViewerPage, getActivities], (viewerPage, allActivities) => {
    if (
      viewerPage?.type !== ViewerPanelPageTypesEnum.SINGLE_CONVERSATION ||
      viewerPage.status !== AsyncStatusesEnum.LOADED
    ) {
      return undefined;
    }

    const {activities} = viewerPage;
    return _(activities)
      .keys()
      .map((id) => allActivities[Number(id)])
      .compact()
      .value();
  });
}

/** Get the messages for the currently selected conversation. */
export function makeGetViewerMessages<P>(getViewerPage: OptionalViewerPanelPageSelector<P>) {
  const getViewerActivities = makeGetViewerActivities(getViewerPage);
  return createSelector([getViewerActivities, getMessages], (activities, allMessages) =>
    _(activities)
      .sortBy((a) => a.date)
      .map((a) => {
        if (a.visualType !== ActivityVisualTypesEnum.MESSAGE) {
          return null;
        }

        return allMessages[a.messageUid];
      })
      .compact()
      .value(),
  );
}
